import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { toastr } from 'react-redux-toastr';
import { getAllControllingPersons } from './getAllControllingPersons';

export const EXPIRE_CONTROLLING_PERSON_REQUEST = 'EXPIRE_CONTROLLING_PERSON_REQUEST';
export const EXPIRE_CONTROLLING_PERSON_SUCCESS = 'EXPIRE_CONTROLLING_PERSON_SUCCESS';
export const EXPIRE_CONTROLLING_PERSON_FAILURE = 'EXPIRE_CONTROLLING_PERSON_FAILURE';

function request() {
  return {
    type: EXPIRE_CONTROLLING_PERSON_REQUEST
  };
}

function receive() {
  return {
    type: EXPIRE_CONTROLLING_PERSON_SUCCESS,
  };
}

function fail() {
  return {
    type: EXPIRE_CONTROLLING_PERSON_FAILURE,
  };
}

export function expireControllingPerson(controllingPersonId, accountId, effectiveDate) {
  return (dispatch) => {
    dispatch(request());
    const promise = () => ApiService
      .expireControllingPerson(controllingPersonId, accountId, effectiveDate)
      .then((response) => {
        dispatch(receive());
        toastr.success('Success', 'Controlling person unlinked successfully');
        dispatch(getAllControllingPersons(accountId));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, fail, true));
        }
      });
    return promise();
  };
}
